import { useEffect } from 'react';
import {
  generatePath,
  Outlet,
  useNavigate,
  useMatch,
  useParams,
} from 'react-router-dom';
import { useAppSelector } from '@store';
import ChartCategoriesColumn from '../../../components/charts/column/column-categories';
import {
  useGetCreateCategoryValidatorQuery,
  useGetAccountsCategoriesQuery,
} from '../store/services/categories';

import ROUTES from '../../../routes';

import sharedStyles from '../styles.module.css';

const ChartCategories = (): React.JSX.Element => {
  const navigate = useNavigate();

  const { groupId, primaryAccountId } = useParams();

  const { categories } = useAppSelector((state) => state.charts.categories);

  const match = useMatch(ROUTES.CHARTS_OF_ACCOUNTS);

  useGetCreateCategoryValidatorQuery();

  const { isLoading } = useGetAccountsCategoriesQuery('all=true');

  useEffect(() => {
    if (match && categories.length) {
      navigate(
        generatePath(ROUTES.CATEGORIES, { categoryId: categories[0].id }),
        { replace: true },
      );
    }
  }, [categories, match]);

  return (
    <>
      <div className={sharedStyles.columnWrapper}>
        <ChartCategoriesColumn
          categories={categories}
          isLoading={isLoading}
          groupId={groupId}
          primaryAccountId={primaryAccountId}
        />
      </div>
      <Outlet />
    </>
  );
};

export default ChartCategories;
